module.exports = __webpack_public_path__ + "media/dashboard/assets/images/contact-socials/linkedIn-7e0398db98fa32bbe38d108a2109694c.svg";